export const DISMISS_ANSWER_FROM_PROCESS_STATEMENT_FAILURE = 'DISMISS_ANSWER_FROM_PROCESS_STATEMENT_FAILURE';

export const dismissAnswerFromProcessStatementFailure = error => ({
    type: DISMISS_ANSWER_FROM_PROCESS_STATEMENT_FAILURE,
    payload: error,
    error: true,
});
